export const socialAccounts = {
  card: {
    description: 'Conectá tu cuenta de LinkedIn para que Referent publique en tu nombre.',
    personalScopeBadge: 'Conexión personal',
    personalScopeHint:
      'Esta conexión es solo tuya: a diferencia del resto de las integraciones de esta página, no se comparte con tu organización.',
    disconnectedHint: 'LinkedIn dejó de aceptar esta conexión. Reconectá para volver a publicar.',
    erroredHint:
      'El servicio de conexión tiene un problema temporal de su lado. Se reintenta automáticamente — no hace falta que hagas nada.',
    pausedHint:
      'Esta conexión está pausada por un problema de suscripción. Nuestro equipo ya está en eso.',
    unnamedAccount: 'Cuenta de LinkedIn',
    viewProfile: 'Ver perfil',
  },

  status: {
    connected: 'Conectada',
    disconnected: 'Sesión vencida',
    errored: 'Interrupción del servicio',
    paused: 'Pausada',
    notConnected: 'Sin conectar',
    unknown: 'Estado desconocido',
  },

  actions: {
    connect: 'Conectar',
    reconnect: 'Reconectar',
    redirecting: 'Redirigiendo…',
    disconnect: 'Desconectar',
    dismiss: 'Cerrar',
    tryAgain: 'Intentar de nuevo',
    checkAgain: 'Volver a chequear',
  },

  returnBanner: {
    waiting: 'Estamos finalizando tu conexión con LinkedIn… suele tardar unos segundos.',
    connected: 'Tu cuenta de LinkedIn quedó conectada.',
    failed: 'No pudimos completar la conexión con LinkedIn.',
    timedOut: 'Está tardando más de lo esperado. Puede que la conexión todavía esté en camino.',
  },

  errorState: {
    title: 'No pudimos cargar tu conexión con LinkedIn.',
    retry: 'Reintentar',
  },

  toast: {
    connectFailed: 'No pudimos iniciar la conexión con LinkedIn. Intentá de nuevo.',
    disconnected: 'Cuenta de LinkedIn desconectada.',
    disconnectFailed: 'No pudimos desconectar tu cuenta de LinkedIn. Intentá de nuevo.',
  },
}
